<template>
  <span 
    id="Group-claims">
    <span class="heading-6">
      <span
        id="selectionCount"
        style="margin-left: 10px">{{ getCountUnfactoredClaims() }}</span>
      <span style="margin-left: 10px">{{ 'krita.claims.items' | translate }}</span>
      <span
        id="selectionAmount"
        style="margin-left: 10px">{{ getAmountUnfactoredClaims() | amount }}</span>
    </span>
    <module-button
      :disabled="faktorBtnDisable"
      :values="faktorBtn"
      :loading="creatingFactoring"
      :dialog="creatingFactoring"
      @confirmClick="$emit('createFactoring')"/>
    <span
      class="pseudolink"
      style="margin-left: 10px"
      @click="$emit('clearState', 'unfactored')">{{ 'krita.claims.clear' | translate }}</span>
  </span>
</template>

<script>
import ModuleButton from '../controllers/ModuleButton.vue';
    export default {
        name: "UnfactoredClaimsControllers",
        components: {ModuleButton},
        props:['unfactoredClaims', 'creatingFactoring'],
        computed: {
            faktorBtn ()
            {
                let text = this.$t('krita.claims.faktormodal.part1') + ' ' + this.getCountUnfactoredClaims() + ' ' + this.$t('krita.claims.faktormodal.part2') + ' ' + this.amountUnfactoredClaims + '\n' +
                    '\n' + ' ' +
                    this.$t('krita.claims.faktormodal.part3');
                let faktorBtnClient;
                return faktorBtnClient = {
                    icon: '',
                    headline: this.$t('krita.claims.faktorclaims'),
                    confirmBtnText: this.$t('krita.claims.createapplication'),
                    openBtnText: this.$t('krita.claims.faktor'),
                    text: text,
                    openBtnColor: '#16DB94',
                    confirmBtnColor: '#16DB94',
                    btnTextColour: 'red--text'
                };
            },
            amountUnfactoredClaims()
            {
                let amountUnfactored = this.getAmountUnfactoredClaims();
                return [Math.ceil(amountUnfactored).toLocaleString('de-DE'), ' kr.'].join('').replace(',','.');
            },
            faktorBtnDisable ()
            {
                if (this.getCountUnfactoredClaims() === 0)
                {
                    return true;
                }
                return false;
            },
        },
        methods: {
            getCountUnfactoredClaims()
            {
                let self = this;


                let count = 0;
                for (let claim of self.unfactoredClaims)
                {
                    if (claim.added)
                    {
                        count++;
                    }
                }
                return count;
            },
            getAmountUnfactoredClaims()
            {
                let self = this;

                let amount = 0;
                for (let claim of self.unfactoredClaims)
                {
                    if (claim.added)
                    {
                        amount = amount + claim.Capital;
                    }
                }
                return amount;
            },
        }
    }
</script>

<style lang="css" scoped>
    .pseudolink {
        color:blue;
        cursor:pointer;
    }
</style>
